import React from "react";
import EventListener from "react-event-listener";
import { Row, Col } from "react-flexbox-grid/lib/index";
import ContainerDimensions from "react-container-dimensions";
import RequireWorkarea from "components/RequireWorkarea";
import RequireOrganization from "components/RequireOrganization";

import { Card, CardContent, Typography } from "@material-ui/core";
import FileDropCard from "./FileDropCard";
import FileListCard from "./FileListCard";

const UploadLayout = props => (
  <RequireOrganization {...props}>
    <RequireWorkarea {...props}>
      {/* Prevent default window action on drag and drop file */}
      <EventListener
        target={window}
        ondrop={e => {
          e.preventDefault();
        }}
      />
      <EventListener
        target={window}
        ondragover={e => {
          e.preventDefault();
        }}
      />

      <Row>
        <Col xs={12} sm={11} md={10} lg={6}>
          <FileDropCard {...props} />
        </Col>

        <Col xs={12} sm={11} md={10} lg={6}>
          <ContainerDimensions>
            <FileListCard {...props} />
          </ContainerDimensions>
        </Col>
      </Row>
      <Row style={{ marginTop: "20px" }}>
        <Col xs={6}>
          <Card>
            <CardContent>
              <Typography component="span" color="textSecondary">
                Note: <code>*_eng.txt</code> are no longer necessary if the
                corresponding <code>.rsk</code> file has been uploaded
              </Typography>
            </CardContent>
          </Card>
        </Col>
      </Row>
    </RequireWorkarea>
  </RequireOrganization>
);

export default UploadLayout;
